import { render, staticRenderFns } from "./menu-avatar.vue?vue&type=template&id=068d0592&"
import script from "./menu-avatar.vue?vue&type=script&lang=js&"
export * from "./menu-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports